module.exports = __webpack_public_path__ + "img/exit_form.bc20f11d.png";